import React from 'react';
import cn from 'classnames';

import styles from './TaskLoader.module.css';

const TaskLoader = ({ delay }) => (
  <svg
    viewBox="0 0 24 24"
    className={cn(styles.svgWrapper, 'w-6 h-6 overflow-visible', delay === 0 ? styles.static : '')}
  >
    <g className={styles.loader}>
      <rect width="24" height="24" rx="12" fill="#3E74FF" />
      <path
        opacity="0.65"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.6V8.6C11.67 8.6 11.4 8.33 11.4 8V5.6C11.4 5.27 11.67 5 12 5V5C12.33 5 12.6 5.27 12.6 5.6V8C12.6 8.33 12.33 8.6 12 8.6"
        fill="white"
      />
      <path
        opacity="0.75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6996 9.05535V9.05535C13.4138 8.89035 13.315 8.52155 13.48 8.23575L14.68 6.15735C14.845 5.87155 15.2138 5.77275 15.4996 5.93775V5.93775C15.7854 6.10275 15.8842 6.47155 15.7192 6.75735L14.5192 8.83575C14.3542 9.12155 13.9854 9.22035 13.6996 9.05535"
        fill="white"
      />
      <path
        opacity="0.85"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.944 10.2999V10.2999C14.779 10.0141 14.8778 9.64531 15.1636 9.48031L17.242 8.28031C17.5278 8.11531 17.8966 8.21411 18.0616 8.49991V8.49991C18.2266 8.78571 18.1278 9.15451 17.842 9.31951L15.7636 10.5195C15.4778 10.6845 15.109 10.5857 14.944 10.2999"
        fill="white"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4 12V12C15.4 11.67 15.67 11.4 16 11.4H18.4C18.73 11.4 19 11.67 19 12V12C19 12.33 18.73 12.6 18.4 12.6H16C15.67 12.6 15.4 12.33 15.4 12"
        fill="white"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.944 13.6999V13.6999C15.109 13.4141 15.4778 13.3153 15.7636 13.4803L17.842 14.6803C18.1278 14.8453 18.2266 15.2141 18.0616 15.4999V15.4999C17.8966 15.7857 17.5278 15.8845 17.242 15.7195L15.1636 14.5195C14.8778 14.3545 14.779 13.9857 14.944 13.6999"
        fill="white"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6996 14.9444V14.9444C13.9854 14.7794 14.3542 14.8782 14.5192 15.164L15.7192 17.2424C15.8842 17.5282 15.7854 17.897 15.4996 18.062V18.062C15.2138 18.227 14.845 18.1282 14.68 17.8424L13.48 15.764C13.315 15.4782 13.4138 15.1094 13.6996 14.9444"
        fill="white"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.4V15.4C12.33 15.4 12.6 15.67 12.6 16V18.4C12.6 18.73 12.33 19 12 19V19C11.67 19 11.4 18.73 11.4 18.4V16C11.4 15.67 11.67 15.4 12 15.4"
        fill="white"
      />
      <path
        opacity="0.35"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2995 14.9444V14.9444C10.5853 15.1094 10.6841 15.4782 10.5191 15.764L9.31914 17.8424C9.15414 18.1282 8.78534 18.227 8.49954 18.062V18.062C8.21374 17.897 8.11494 17.5282 8.27994 17.2424L9.47994 15.164C9.64494 14.8782 10.0137 14.7794 10.2995 14.9444"
        fill="white"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05532 13.6999V13.6999C9.22032 13.9857 9.12152 14.3545 8.83572 14.5195L6.75732 15.7195C6.47152 15.8845 6.10272 15.7857 5.93772 15.4999V15.4999C5.77272 15.2141 5.87152 14.8453 6.15732 14.6803L8.23572 13.4803C8.52152 13.3153 8.89032 13.4141 9.05532 13.6999"
        fill="white"
      />
      <path
        opacity="0.45"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6 12V12C8.6 12.33 8.33 12.6 8 12.6H5.6C5.27 12.6 5 12.33 5 12V12C5 11.67 5.27 11.4 5.6 11.4H8C8.33 11.4 8.6 11.67 8.6 12"
        fill="white"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05532 10.2999V10.2999C8.89032 10.5857 8.52152 10.6845 8.23572 10.5195L6.15732 9.31951C5.87152 9.15451 5.77272 8.78571 5.93772 8.49991V8.49991C6.10272 8.21411 6.47152 8.11531 6.75732 8.28031L8.83572 9.48031C9.12152 9.64531 9.22032 10.0141 9.05532 10.2999"
        fill="white"
      />
      <path
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2995 9.05535V9.05535C10.0137 9.22035 9.64494 9.12155 9.47994 8.83575L8.27994 6.75735C8.11494 6.47155 8.21374 6.10275 8.49954 5.93775V5.93775C8.78534 5.77275 9.15414 5.87155 9.31914 6.15735L10.5191 8.23575C10.6841 8.52155 10.5853 8.89035 10.2995 9.05535"
        fill="white"
      />
    </g>
    <g className={styles.checkWrapper} style={{ animationDelay: `${delay - 1000}ms` }}>
      <rect width="24" height="24" rx="12" fill="#7ED321" />
      <path
        d="M6 11.5L10.375 16.125L18.5 8"
        className={styles.checkIcon}
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="transparent"
        style={{ animationDelay: `${delay - 900}ms` }}
      />
    </g>
  </svg>
);

export default TaskLoader;
